import { useEffect } from 'react';
import { Spinner } from '@facephi/ui-react';
import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useOperationId } from '../hooks';
import { useAuth } from '../providers';
import { RoutesName } from '../states';
import { operationIdState } from '../states/atoms/operationId';

type IProps = {
  acceptedTerms?: boolean;
  operation?: boolean;
  operationProvider?: boolean;
  ownOperationId?: boolean;
};

export const ProtectedRoute = ({
  acceptedTerms,
  operation,
  ownOperationId,
}: IProps) => {
  const { logged, terms, loadingTerms } = useAuth();
  const { checkOperationIdExist } = useOperationId();
  const { operationId: operationIdQuery } = useParams();
  const location = useLocation();
  const [operationId, setOperationId] = useRecoilState(operationIdState);
  const isTermsPage = location.pathname === RoutesName.terms;

  const hasTerms = !acceptedTerms || terms;
  const hasOperation = !operation || !!operationId;
  const hasOperationId =
    !ownOperationId || checkOperationIdExist(operationIdQuery);

  useEffect(() => {
    operationIdQuery && setOperationId(operationIdQuery);
  }, [operationIdQuery]);

  if (terms && isTermsPage) return <Navigate to={RoutesName.home} />;

  return (
    <>
      {logged ? (
        loadingTerms ? (
          <Spinner />
        ) : !hasTerms ? (
          <Navigate to={RoutesName.terms} />
        ) : !hasOperation || !hasOperationId ? (
          <Navigate to={RoutesName.home} />
        ) : (
          <Outlet />
        )
      ) : (
        <Navigate to={RoutesName.login} />
      )}
    </>
  );
};
